export const PrimaryInputFieldType = Object.freeze({
  DROPDOWN: "dropdown",
  TEXT: "text",
  EMAIL: "email",
  PASSWORD: "password",
  TEXTAREA: "textarea",
  DATE: "date",
  NUMBER: "number",
  TIME: "time",
  CUSTOM: "custom",
  DIAGNOSIS: "diagnosis",
  ICD: "icd",
  TREATMENTS: "treatment",
  PRESCRIPTION: "prescription",
  INFORMATION: "information",
  MULTI_SELECT: "dropdown-multi",
  DOB: "dob",
});
